(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-insurance-form]');
    const rent = form.querySelector('[data-rent]');
    const output = root.querySelector('[data-estimate]');
    const iban = form.querySelector('[data-iban]');
    const status = form.querySelector('[data-status]');
    const money = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    function estimate() {
      const amount = Number(rent.value);
      output.textContent = amount > 0 ? money.format(amount * 404 / 730) + ' ' + root.dataset.annual : root.dataset.emptyEstimate;
    }
    function validIban(value) {
      if (!value) return true;
      if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(value)) return false;
      if (value.startsWith('ES') && !/^ES\d{22}$/.test(value)) return false;
      const rearranged = value.slice(4) + value.slice(0, 4);
      let remainder = 0;
      for (const character of rearranged) {
        const digits = /[A-Z]/.test(character) ? String(character.charCodeAt(0) - 55) : character;
        for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
      }
      return remainder === 1;
    }
    function checkIban() {
      iban.setCustomValidity(validIban(iban.value.replace(/\s/g, '').toUpperCase()) ? '' : root.dataset.ibanError);
    }
    form.querySelectorAll('[data-toggle-person]').forEach(toggle => {
      toggle.addEventListener('change', () => {
        const group = form.querySelector('[data-person="' + toggle.dataset.togglePerson + '"]');
        group.hidden = !toggle.checked;
        group.disabled = !toggle.checked;
      });
    });
    rent.addEventListener('input', estimate);
    iban.addEventListener('input', checkIban);
    form.addEventListener('submit', event => {
      event.preventDefault();
      checkIban();
      if (!form.reportValidity()) return;
      if (event.submitter?.value === 'email') {
        const destination = root.dataset.recipient;
        window.location.href = 'mailto:' + encodeURIComponent(destination) + '?subject=' + encodeURIComponent(root.dataset.subject) + '&body=' + encodeURIComponent(root.dataset.mailBody);
        status.textContent = root.dataset.opened;
        return;
      }
      const lines = [root.dataset.subject, new Date().toLocaleString('es-ES'), '', root.dataset.estimateLabel + ': ' + output.textContent, root.querySelector('.ok-insurance__estimate + p').textContent, ''];
      form.querySelectorAll('fieldset').forEach(group => {
        if (group.disabled) return;
        lines.push(group.dataset.personLabel || '', '');
        group.querySelectorAll('[name]').forEach(input => {
          if (input.value) lines.push(input.dataset.label + ': ' + input.value);
        });
        lines.push('');
      });
      const coverage = form.elements.namedItem('coverage');
      lines.push(coverage.dataset.label + ': ' + coverage.value);
      const notes = form.elements.namedItem('notes');
      if (notes.value) lines.push(notes.dataset.label + ': ' + notes.value);
      lines.push('', root.dataset.privacyRecord);
      const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'OKHOMES-expediente-seguro-impago.txt';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 30000);
      status.textContent = root.dataset.downloaded;
    });
    estimate();
  }
  document.querySelectorAll('[data-insurance]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-insurance]').forEach(initialize));
})();
